<form [formGroup]="borrowerDetails" id="borrower-details" 
(ngSubmit)=onSubmit(borrowerDetails)>
	<div class="d-flex flex-column justify-content-center text-center flex-column m-step-wrapper1 container" [ngClass]="{'first-question' : !prevQID}">
		<questions-manager [(editQid)]="qID" [visibleQids]="visibleQids" 
			[(editQuestion)]="editQuestion" 
			(editQuestionChange)="editQuestionChange($event)">

			<!-- question 1 - more borrowers? -->
			<question [qID]="'1'">
					<h3>{{"BORROWERS_DETAILS.QUESTION1.QUESTION"|translate}}</h3>
					<div class="btn-group-toggle" data-toggle="buttons">
						<label class="btn btn-primary" 
						[ngClass]="{'selected':borrowerDetails.get('areThereAdditionalBorrowers').value==='YES'}">
							{{"COMMON.YES"|translate}}
							<input type="radio" 
							formControlName="areThereAdditionalBorrowers" 
							value="YES" (change)="onSubmit(borrowerDetails)" click2change>
						</label>
						<label class="btn btn-primary" 
						[ngClass]="{'selected':borrowerDetails.get('areThereAdditionalBorrowers').value==='NO'}">
							{{"COMMON.NO"|translate}}
							<input type="radio" formControlName="areThereAdditionalBorrowers" value="NO" (change)="onSubmit(borrowerDetails)" click2change>
						</label>
					</div>
					<!-- <small class="m-error form-text mt-5" *ngIf="borrowerDetails.get('areThereAdditionalBorrowers').hasError('noIncome') && submitted">
						{{"BORROWERS_DETAILS.QUESTION22.NO_INCOME_ERROR"|translate}}
					</small> -->
			</question>
			<!-- question 2 - borrowers detail array -->
            <question [qID]="'2'">
                <h3 class="d-flex justify-content-center">{{"BORROWERS_DETAILS.QUESTION2.QUESTION"|translate}}</h3>
                <app-borrowers-array formArrayName="borrowersArray"
                                     (onAddFormGroup)="setValidators()"
                                     [qID]="2" [borrowersArray]="borrowerDetails.get('borrowersArray')"
                                     [displayErrors]="submitted"
                                     [showRemove]="editQuestion !== '2' && qID==='2'">
                </app-borrowers-array>
                <div class="m-error form-text"
                     *ngIf="errowAddBrrower">
                    {{ 'BORROWERS_DETAILS.QUESTION1.REQUIRED' | translate }}
                </div>
                <div class="mt-3 d-flex justify-content-center text-center">
                    <button type="submit" class="btn btn-primary"
                            [ngClass]="{'m-valid' : borrowerDetails.valid && qID=='2'}">
                        {{"BORROWERS_DETAILS.QUESTION2.BUTTON_SAVE"|translate}}
                    </button>
                </div>
            </question>

			<!-- loop each borrower -->
			<ng-container *ngFor="let borrower of borrowers;let i = index" ngProjectAs="question">

				<!--question 3 -->
				<question [qID]="getqID(3, i)">
					<h2>{{'BORROWERS_DETAILS.QUESTION3.QUESTION'|translate: {name: borrowers[i].fields[1].answerValue || ''} }}</h2>
					<div class="mt-4">
						<box-selector formControlName="brwEmploymentStatus-{{i+1}}" [options]="options" 
						(optionClicked)="onSubmit(borrowerDetails)"></box-selector>
					</div>
				</question>
	
				<!--employee-->
				<question [qID]="getqID('4a', i)">
					<div>
						<h3>{{"BORROWERS_DETAILS.QUESTION4.QUESTION4a"|translate:  {name: borrowers[i].fields[1].answerValue || ''} }}</h3>
						<div class="form-group">
							<input type="text" 
							formControlName="brwEmployersCompanyName-{{i+1}}" class="m-form-control2 form-control"
							placeholder="{{'BORROWERS_DETAILS.QUESTION4.PH4a'|translate}}">
							<div class="m-error form-text" 
								*ngIf="borrowerDetails.get('brwEmployersCompanyName-'+ (i+1)).hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text" 
								*ngIf="borrowerDetails.get('brwEmployersCompanyName-'+ (i+1)).hasError('pattern') && submitted">
								{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
						</div>
						<div class="d-flex justify-content-center">
							<button type="submit" class="btn btn-primary" 
									[ngClass]="{'m-valid' : borrowerDetails.valid && qID=='4a'}">
									{{"COMMON.PROCEED"|translate}}
							</button>
						</div>
					</div>
				</question>
				<question [qID]="getqID('5a', i)">
					<h3>{{"BORROWERS_DETAILS.QUESTION5.QUESTION5a"|translate: {name: borrowers[i].fields[1].answerValue || ''} }}</h3>
					<div class="d-flex flex-column flex-md-row justify-content-center text-center">
						<div>
							<div class="mx-1 form-group">
								<input type="text" 
									formControlName="brwEmployersCompanyField-{{i+1}}" class="m-form-control2 form-control"
									placeholder="{{'BORROWERS_DETAILS.QUESTION5.PH5a1'|translate}}">
								<div class="m-error form-text" 
									*ngIf="borrowerDetails.get('brwEmployersCompanyField-'+ (i+1)).hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</div>
								<div class="m-error form-text" 
									*ngIf="borrowerDetails.get('brwEmployersCompanyField-'+ (i+1)).hasError('pattern') && submitted">
									{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
								</div>
							</div>
							<div class="mx-1 form-group">
								<input type="text" 
									formControlName="brwEmployersProfession-{{i+1}}" class="m-form-control2 form-control"
									placeholder="{{'BORROWERS_DETAILS.QUESTION5.PH-profetional'|translate}}">
								<div class="m-error form-text" 
									*ngIf="borrowerDetails.get('brwEmployersProfession-'+ (i+1)).hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</div>
								<div class="m-error form-text" 
									*ngIf="borrowerDetails.get('brwEmployersProfession-'+ (i+1)).hasError('pattern') && submitted">
									{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
								</div>
							</div>
						</div>
						<div>
							<div class="mx-1 form-group">
								<input type="number" formControlName="brwEmployersCompanySeniority-{{i+1}}"
									class="m-form-control2 form-control" step="0.5" min="0.5" max="70"
									placeholder="{{'BORROWERS_DETAILS.QUESTION5.PH5a2'|translate}}">
								<div class="m-error form-text"
									*ngIf="borrowerDetails.get('brwEmployersCompanySeniority-'+ (i+1)).hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</div>
								<div class="m-error form-text" *ngIf="borrowerDetails.get('brwEmployersCompanySeniority-'+ (i+1)).hasError('pattern') && submitted">
									{{ 'USER_MORE_DETAILS.QUESTION3.PH-3-1-b3-valid' | translate }}
								</div>
							</div>
							<div class="mx-1 form-group">
								<input type="text" placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-2-yeshuv'|translate}}" aria-label="Number" matInput
									formControlName="brwYeshuvAvodaForEmployee-{{i+1}}" [matAutocomplete]="autoCityForEmployee"
									class="m-form-control2 form-control">
								<mat-autocomplete #autoCityForEmployee="matAutocomplete">
									<mat-option *ngFor="let city of  getCityFilterListForEmployee(i) | async" [value]="city.name">
										{{ city.name }}
									</mat-option>
								</mat-autocomplete>
			
			
								<div class="m-error form-text"
									*ngIf="borrowerDetails.get('brwYeshuvAvodaForEmployee-'+ (i+1)).hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</div>
								<div class="m-error form-text"
									*ngIf="borrowerDetails.get('brwYeshuvAvodaForEmployee-'+ (i+1)).hasError('isNotInCityList') && !borrowerDetails.get('brwYeshuvAvodaForEmployee-'+ (i+1)).hasError('required') && submitted">
									{{'COMMON.NOT_IN_LIST_ERROR' | translate}}
								</div>
			
							</div>
						</div>
					</div>
					<button type="submit" class="btn btn-primary" 
						[ngClass]="{'m-valid' : borrowerDetails.valid && qID=='5a'}">
						{{"COMMON.PROCEED"|translate}}
					</button>
				</question>
                <question [qID]="getqID('6a', i)">
                    <div>
                        <h3>{{"BORROWERS_DETAILS.QUESTION6.QUESTION6a"|translate: {name: borrowers[i].fields[1].answerValue || ''} }}</h3>
                        <div class="mx-1 form-group">
                            <input formControlName="brwEmployersMonthlyIncome-{{i+1}}"
                                   class="m-form-control2 form-control"
                                   currencyMask type="tel"
                                   placeholder="{{'BORROWERS_DETAILS.QUESTION6.PH6a'|translate}}">
                            <div class="form-text m-error"
                                 *ngIf="borrowerDetails.get('brwEmployersMonthlyIncome-'+ (i+1)).hasError('required') && submitted">
                                {{ 'COMMON.FIELD_REQUIRED' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary"
                                [ngClass]="{'m-valid' : borrowerDetails.valid && qID=='6a'}">
                            {{"COMMON.PROCEED"|translate}}
                        </button>
                    </div>
                </question>
				<!--END employee-->

				<!--independent-->
				<question [qID]="getqID('4b', i)">
					<div>
						<h3>{{"BORROWERS_DETAILS.QUESTION4.QUESTION4b"|translate:  {name: borrowers[i].fields[1].answerValue || ''} }}</h3>
						<div class="form-group">
							<input type="text" 
							formControlName="brwIndependentCompanyName-{{i+1}}" class="m-form-control2 form-control"
							placeholder="{{'BORROWERS_DETAILS.QUESTION4.PH4b'|translate}}">
							<div class="m-error form-text" 
								*ngIf="borrowerDetails.get('brwIndependentCompanyName-'+ (i+1)).hasError('required') && submitted">
								{{ 'COMMON.FIELD_REQUIRED' | translate }}
							</div>
							<div class="m-error form-text" 
								*ngIf="borrowerDetails.get('brwIndependentCompanyName-'+ (i+1)).hasError('pattern') && submitted">
								{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
							</div>
						</div>
						<div class="d-flex justify-content-center">
							<button type="submit" class="btn btn-primary" 
									[ngClass]="{'m-valid' : borrowerDetails.valid && qID=='4b'}">
									{{"COMMON.PROCEED"|translate}}
							</button>
						</div>
					</div>
				</question>
				<question [qID]="getqID('5b', i)">
					<h3>{{"BORROWERS_DETAILS.QUESTION5.QUESTION5b"|translate: {name: borrowers[i].fields[1].answerValue || ''} }}</h3>
					<div class="d-flex flex-column flex-md-row justify-content-center text-center">
						<div>
							<div class="mx-1 form-group">
								<input type="text" 
									formControlName="brwIndependentCompanyField-{{i+1}}" class="m-form-control2 form-control"
									placeholder="{{'BORROWERS_DETAILS.QUESTION5.PH5b1'|translate}}">
								<div class="m-error form-text" 
									*ngIf="borrowerDetails.get('brwIndependentCompanyField-'+ (i+1)).hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</div>
								<div class="m-error form-text" 
									*ngIf="borrowerDetails.get('brwIndependentCompanyField-'+ (i+1)).hasError('pattern') && submitted">
									{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
								</div>
							</div>
							<div class="mx-1 form-group">
								<input type="text" 
									formControlName="brwIndependentProfession-{{i+1}}" class="m-form-control2 form-control"
									placeholder="{{'BORROWERS_DETAILS.QUESTION5.PH-profetional'|translate}}">
								<div class="m-error form-text" 
									*ngIf="borrowerDetails.get('brwIndependentProfession-'+ (i+1)).hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</div>
								<div class="m-error form-text" 
									*ngIf="borrowerDetails.get('brwIndependentProfession-'+ (i+1)).hasError('pattern') && submitted">
									{{ 'COMMON.GENERAL_PATTERN_ERROR' | translate }}
								</div>
							</div>
						</div>
						<div>
							<div class="mx-1 form-group">
								<input type="number" formControlName="brwIndependentCompanySeniority-{{i+1}}"
									class="m-form-control2 form-control" step="0.5" min="0.5" max="70"
									placeholder="{{'BORROWERS_DETAILS.QUESTION5.PH5b2'|translate}}">
								<div class="m-error form-text" 
									*ngIf="borrowerDetails.get('brwIndependentCompanySeniority-'+ (i+1)).hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</div>
								<div class="m-error form-text" *ngIf="borrowerDetails.get('brwIndependentCompanySeniority-'+ (i+1)).hasError('pattern') && submitted">
									{{ 'USER_MORE_DETAILS.QUESTION3.PH-3-1-b3-valid' | translate }}
								</div>
							</div>
							<div class="mx-1 form-group">
								<input type="text" placeholder="{{'USER_MORE_DETAILS.QUESTION3.PH-3-2-yeshuv'|translate}}" aria-label="Number" matInput
									formControlName="brwYeshuvAvodaForIndependent-{{i+1}}" [matAutocomplete]="autoCityForIndependent"
									class="m-form-control2 form-control">
								<mat-autocomplete #autoCityForIndependent="matAutocomplete">
									<mat-option *ngFor="let city of  getCityFilterListForIndependent(i) | async" [value]="city.name">
										{{ city.name }}
									</mat-option>
								</mat-autocomplete>
			
			
								<div class="m-error form-text"
									*ngIf="borrowerDetails.get('brwYeshuvAvodaForIndependent-'+ (i+1)).hasError('required') && submitted">
									{{ 'COMMON.FIELD_REQUIRED' | translate }}
								</div>
								<div class="m-error form-text"
									*ngIf="borrowerDetails.get('brwYeshuvAvodaForIndependent-'+ (i+1)).hasError('isNotInCityList') && !borrowerDetails.get('brwYeshuvAvodaForIndependent-'+ (i+1)).hasError('required') && submitted">
									{{'COMMON.NOT_IN_LIST_ERROR' | translate}}
								</div>
			
							</div>
						</div>
					</div>
					<button type="submit" class="btn btn-primary" 
						[ngClass]="{'m-valid' : borrowerDetails.valid && qID=='5b'}">
						{{"COMMON.PROCEED"|translate}}
					</button>
				</question>
                <question [qID]="getqID('6b', i)">
                    <div>
                        <h3>{{"BORROWERS_DETAILS.QUESTION6.QUESTION6b"|translate: {name: borrowers[i].fields[1].answerValue || ''} }}</h3>
                        <div class="mx-1 form-group">
                            <input formControlName="brwIndependentYearlyIncome-{{i+1}}"
                                   class="m-form-control2 form-control"
                                   currencyMask type="tel"
                                   placeholder="{{'BORROWERS_DETAILS.QUESTION6.PH6b'|translate}}">
                            <div class="form-text m-error"
                                 *ngIf="borrowerDetails.get('brwIndependentYearlyIncome-'+ (i+1)).hasError('required') && submitted">
                                {{ 'COMMON.FIELD_REQUIRED' | translate }}
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary"
                                [ngClass]="{'m-valid' : borrowerDetails.valid && qID=='6b'}">
                            {{"COMMON.PROCEED"|translate}}
                        </button>
                    </div>
                </question>
				<!--END independent-->

				<!--incomes-->
				<question [qID]="getqID('7a', i)">
					<h3>{{"BORROWERS_DETAILS.QUESTION7.QUESTION-A"|translate: {name:borrowers[i].fields[1].answerValue || ''} }}</h3>
					<div class="btn-group-toggle" data-toggle="buttons">
						<label class="btn btn-primary" 
						[ngClass]="{'selected':borrowerDetails.get('brwAreThereOtherIncome-'+ (i+1)).value==='YES'}">
							{{"COMMON.YES"|translate}}
							<input type="radio" 
							formControlName="brwAreThereOtherIncome-{{i+1}}" 
							value="YES" (change)="onSubmit(borrowerDetails)" click2change>
						</label>
						<label class="btn btn-primary" 
						[ngClass]="{'selected':borrowerDetails.get('brwAreThereOtherIncome-'+ (i+1)).value==='NO'}">
							{{"COMMON.NO"|translate}}
							<input type="radio" formControlName="brwAreThereOtherIncome-{{i+1}}" value="NO" 
							(change)="onSubmit(borrowerDetails)" click2change>
						</label>
					</div>
				</question>

				<question [qID]="getqID('7b', i)">
					<h3>{{"BORROWERS_DETAILS.QUESTION7.QUESTION" | translate: {name:borrowers[i].fields[1].answerValue || ''} }}</h3>
					<app-incomes-array formArrayName="brwOtherIncome-{{i+1}}" 
						(onAddFormGroup)="setValidators()" 
						[needSources]="true" 
						(onIncomesChange)="setValidators()" 
						[incomeTypes]="typeCmbo" 
						[incomesFormArray]="borrowerDetails.get('brwOtherIncome-'+ (i+1))"
						[displayErrors]="submitted" 
						[titles]="['BORROWERS_DETAILS.QUESTION7.LABEL1', 'BORROWERS_DETAILS.QUESTION7.LABEL2', 'BORROWERS_DETAILS.QUESTION7.LABEL3']" 
						[ph]="['BORROWERS_DETAILS.QUESTION7.LABEL1_PH' | translate,'BORROWERS_DETAILS.QUESTION7.LABEL3_PH' | translate]"
						[buttons]="['BORROWERS_DETAILS.QUESTION7.BUTTON_ADD','BORROWERS_DETAILS.QUESTION7.BUTTON_ADD_AND_SAVE']">
					</app-incomes-array>
					<button type="submit" 
						class="btn btn-primary" 
						[ngClass]="{'m-valid' : borrowerDetails.valid && qID=='7-'+(i+1)}">
						{{"COMMON.BUTTON_SAVE"|translate}}
					</button>
				</question>

			</ng-container>

		</questions-manager>
	</div>
</form>


// WEBPACK FOOTER //
// ./src/app/borrowers-details/borrowers-details.component.html